import { Society } from 'types';
import { SocietyCorporateId } from 'types/Society';
import { contactsByCorporateId } from '../constants/contactsByCorporateId';

const globalCorporateId = process.env.REACT_APP_UI_CORPORATE_ID;

export const getContactConfigByCorporateId = (society?: Society) => {
  const corporateId = (globalCorporateId ||
    society?.corporateId ||
    SocietyCorporateId.DEFAULT) as SocietyCorporateId;

  return contactsByCorporateId[corporateId];
};
